import React from "react";
import actions from "../../../../store/actions";
import store from "../../../../store/store";
import ComponentChangeLogModalState from "./ComponentChangeLogModalState";
import stringHelper from "../../../../infrastructure/helpers/common/stringHelper";
import CustomIcon from "../../BootstrapIcons/Custom/CustomIcon";
import iconTooltip from "../../BootstrapIcons/Tooltip/IconTooltip";
import { ReactComponent as HistoryIcon } from '../../../Common/BootstrapIcons/history.svg';

interface Props {
    componentType: string,
    componentName: string,
    reportConfigId: number;
    id?: number
}
class ComponentChangeLogIconAndAction extends React.Component<Props> {

    constructor(props: Props) {
        super(props);

        this.onViewChangeLogClick = this.onViewChangeLogClick.bind(this);
    }

    onViewChangeLogClick(): void {

        var type = stringHelper.insertSpaceBeforeEachUppercase(this.props.componentType);

        let state: ComponentChangeLogModalState = {
            reportConfigId:this.props.reportConfigId,
            title: `Change Log for ${type}: ${this.props.componentName}`,
            isOpen: true,
            error: null,
            id: this.props.id || 0,
            componentType: this.props.componentType.replace(/\s+/g, '')
        };

        store.dispatch({ type: actions.componentChangeLogModal.open, payload: state });
    }

    render(): JSX.Element {

        return (
            <button className="custom-icon-button" onClick={() => this.onViewChangeLogClick()}>
                <CustomIcon icon={HistoryIcon} title={iconTooltip.changeLog} />
            </button>
        )
    }
}

export default ComponentChangeLogIconAndAction;
